// PRO-671. The keys are the reserved `system_*` variable names the engine reads; they are hidden from the
// Variables table, so this screen is the only place they are edited.
export const AGENT_SETTING_KEYS = Object.freeze({
  NAME: 'system_agent_name',
  GENDER: 'system_agent_gender',
  ROLE: 'system_agent_role',
  COMPANY: 'system_agent_company',
  FORMALITY: 'system_agent_formality',
  EMOJI: 'system_agent_emoji',
  REPLY_LENGTH: 'system_agent_reply_length'
})

// PRO-705: internal TypeSafe Jev switches. Same reserved `system_*` namespace and the same bot-level
// endpoint as the keys above — they are not persona, but they are bot-level settings behind the same
// "show unreleased" gate, and a second panel plus a second endpoint for two switches is not worth it.
// Intent recognition is NOT here: it is switched on the Intent recognition select (nlp_model provider).
export const TYPESAFE_SETTING_KEYS = Object.freeze({
  JUDGE: 'system_typesafe_judge',
  TOOL_ROUTER: 'system_typesafe_tool_router'
})

// '' is a real choice, not a placeholder: an unset control states nothing in the prompt rather than asserting
// a default the customer never picked.
const UNSET = { value: '', text: 'Not set' }

export const GENDER_OPTIONS = [UNSET, { value: 'female', text: 'Female' }, { value: 'male', text: 'Male' }]

export const FORMALITY_OPTIONS = [UNSET, { value: 'formal', text: 'Formal' }, { value: 'informal', text: 'Informal' }]

export const EMOJI_OPTIONS = [
  UNSET,
  { value: 'none', text: 'No emojis' },
  { value: 'moderate', text: 'In moderation' },
  { value: 'frequent', text: 'Freely' }
]

export const REPLY_LENGTH_OPTIONS = [
  UNSET,
  { value: 'short', text: 'Short and to the point' },
  { value: 'detailed', text: 'Detailed, with reasoning' }
]

// The engine treats only the literal 'true' as on, and a blank value deletes the row — so "off" and
// "never configured" are the same state on both sides.
export const TYPESAFE_SWITCH_OPTIONS = [
  { value: '', text: 'Off (OpenAI)' },
  { value: 'true', text: 'On (TypeSafe Jev)' }
]
